/* eslint-disable import/order */
import { connect } from 'react-redux';

// Components
import { HeroV2 } from './HeroV2';

// Constants
import { CMS_CTA_TYPES } from 'components/CmsPage/modules/CmsCta';
import { DEFAULT_PAGE_PROMOTION_SESSION_KEY } from 'components/PagePromotion/PagePromotionCta';
import { GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS } from 'constants/promotions';
import { VARIABLE_REGEX } from 'helpers/interpolate';

// Decorators
import { withInterpolate } from 'decorators/Interpolate/Interpolate';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith, withName } from 'helpers/decorator';

// Helpers
import { isBlank, isEmpty } from 'helpers/verify';

// Redux/Sagas
import { selectIsMobile } from 'redux/modules/device';
import { setPagePromotion, useSellHeader } from 'redux/modules/page';
import { isLoggedIn } from 'redux/modules/user';
import { readSessionStorage } from 'redux/saga/helpers/local-storage';
import { ctaClick, loadSaga, watchSaga } from './herov2.saga';

const mapCtas = ({ ctas, callToAction, callToActionYouTube }, promoAlias) =>
  (isEmpty(ctas) ? [callToAction || {}, callToActionYouTube || {}] : ctas).map(cta =>
    cta.type === CMS_CTA_TYPES.URL && !cta.url
      ? ((cta.url = promoAlias ? `/pricing/${promoAlias}` : '/pricing'), cta)
      : cta
  );

const mapPromoAlias = ({ promotionAlias }) => {
  // Check to see if we are overriding the default promotion with
  // an Optimizely-provided one.
  if (promotionAlias === GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS) {
    const sessionPromotionAlias = readSessionStorage(DEFAULT_PAGE_PROMOTION_SESSION_KEY, null, true);
    if (!isBlank(sessionPromotionAlias)) {
      return sessionPromotionAlias;
    }
  }

  return promotionAlias;
};

export const mapStateToProps = (state, ownProps) => {
  const isWelcomeHero = !!ownProps.isWelcomeHero && isLoggedIn(state);
  const promoAlias = mapPromoAlias(ownProps);
  const ctas = mapCtas(ownProps, promoAlias);
  const hideHeaderCta = ownProps.hideHeaderCta || isLoggedIn(state);

  return {
    ctas,
    desktopImageUrl: ownProps.desktopImage,
    headerCtaCopy: ownProps.headerCtaCopy,
    heroTextColor: ownProps.heroTextColor || 'dark',
    hideHeaderCta,
    horizontalAlignment: ownProps.alignment,
    isLeadCapture: !!ownProps.leadCapture,
    isMobile: selectIsMobile(state),
    isWelcomeHero,
    legal: ownProps.legal,
    mobileImageUrl: ownProps.mobileImage,
    promoAlias,
    subtitle: ownProps.subtitle || [],
    title: ownProps.title || [],
    titleSize: ownProps.titleSize || 'display',
  };
};

export const mapDispatchToProps = {
  ctaClick,
  setPagePromotion,
  useSellHeader,
};

export const HeroV2Container = decorateWith(
  withInterpolate(VARIABLE_REGEX),
  withSagas({ watch: watchSaga, load: loadSaga }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('HeroV2Container')
)(HeroV2);
